import { render, staticRenderFns } from "./StatsCommercialsV2Static.vue?vue&type=template&id=6fd4524d&scoped=true"
import script from "./StatsCommercialsV2Static.vue?vue&type=script&lang=js"
export * from "./StatsCommercialsV2Static.vue?vue&type=script&lang=js"
import style0 from "./StatsCommercialsV2Static.vue?vue&type=style&index=0&id=6fd4524d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd4524d",
  null
  
)

export default component.exports